var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main__layout"},[_c('Header'),_c('div',{attrs:{"id":"layout__content"}},[_vm._t("default"),_c('SlotCreate')],2),(_vm.isLogin && _vm.navBarIsNeeded())?_c('StaticMenu'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }